import styled from 'styled-components';

export const StyledBackIconWrapper = styled.div`
  z-index: 2;
  display: flex;
  align-items: center;
  position: fixed;
  @media (min-width: calc(${props => props.theme.screenBreakpoints.large} + 0.2px)) {
    position: absolute;
  }
  ${({ isHeaderTransparent, theme }) =>
    isHeaderTransparent
      ? `background-color: transparent; 
  margin-inline-start: ${theme.space[4]}px; 
  top: ${theme.space[4]}px;
  `
      : `
  width: 100%;
  background-color: ${theme.color.white}; 
  padding: ${theme.space[4]}px ${theme.space[4]}px;
  transition: background-color 80ms ease-in-out; 
  box-shadow: 0 0 .5em rgba(0, 0, 0, .5); 
  `}
`;
